import { Component } from '@angular/core';

@Component({
  selector: 'standard-layout',
  template: require('./standard-layout.component.html'),
  styles: [require('./standard-layout.component.scss')],
})
export class StandardLayoutComponent {}
